import { render, staticRenderFns } from "./LoopCAD.vue?vue&type=template&id=0c038a6a&scoped=true"
import script from "./LoopCAD.vue?vue&type=script&lang=js"
export * from "./LoopCAD.vue?vue&type=script&lang=js"
import style0 from "./LoopCAD.vue?vue&type=style&index=0&id=0c038a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c038a6a",
  null
  
)

export default component.exports
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPageSticky,QBtn});
